import React from "react";
import { IconButton } from "@mui/material";
import { useIntl } from "react-intl";
import EditOutlined from "@mui/icons-material/EditOutlined";

import { getPickZoneConfigurationSchema, type PickZone, type PickZoneConfiguration } from "@/schemas";
import { useUpdatePickZone } from "@/hooks/pick-zones";

import { PickZoneConfigurationModal } from "../pick-zone-configuration-modal";

interface PickZoneEditButtonProps {
	readonly pickZone: PickZone;
}

export const PickZoneEditButton: React.FC<PickZoneEditButtonProps> = ({ pickZone }) => {
	const intl = useIntl();

	const [showEdit, setShowEdit] = React.useState(false);
	const { mutateAsync: updatePickZoneAsync, error } = useUpdatePickZone();

	const handleSubmit = async (data: PickZoneConfiguration): Promise<void> => {
		try {
			await updatePickZoneAsync({ pickZoneId: pickZone.id, data });
			setShowEdit(false);
		} catch {
			/* Handled */
		}
	};

	return (
		<>
			<PickZoneConfigurationModal
				open={showEdit}
				onClose={() => setShowEdit(false)}
				onSubmit={handleSubmit}
				error={error}
				defaultValues={getPickZoneConfigurationSchema(intl)
					.enrich({ callSite: "PickZoneEditButton" })
					.parseWithTelemetry(pickZone)}
			/>
			<IconButton onClick={() => setShowEdit(true)} data-testid="pick-zone-edit-button__button__open-modal">
				<EditOutlined />
			</IconButton>
		</>
	);
};
